import script from "./AppLocalChara.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLocalChara.vue?vue&type=script&setup=true&lang=js"

import "./AppLocalChara.vue?vue&type=style&index=0&id=0a5a0f97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a5a0f97"]])

export default __exports__